<template>
    <v-fab
        class="beta-button"
        icon="icon-log"
        color="#3FB8D7"
        size="x-small"
        :style="style"
        @click="onClick"
    />
</template>

<script setup lang="ts">
import { computed, type StyleValue } from 'vue';

const style = computed((): StyleValue => {
    return {
        '--right': '12px'
    };
});

const onClick = (): void => {
    window.open(import.meta.env.VITE_BETA_URL);
};
</script>

<style scoped lang="scss">
@use 'BetaButton.scss';
</style>